var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZircuit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7289_2190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0006C0 5.37271 5.37283 0 11.9997 0C18.6278 0 24.0006 5.37271 24 12C24 14.3475 23.3257 16.5373 22.1608 18.3865C21.8396 18.896 21.4818 19.3795 21.0898 19.8341L12.0156 10.7602L4.21265 18.5624L2.92435 19.8507C2.53113 19.3972 2.17216 18.9143 1.85097 18.4054C0.678393 16.5527 0 14.3557 0 12.0006ZM20.7851 16.6766L20.895 16.457L20.8956 16.4576C21.584 15.0843 21.9477 13.5427 21.9477 12.0006C21.9477 6.51574 17.4853 2.05344 12.0003 2.05344C6.51529 2.05344 2.05348 6.51574 2.05348 12.0006C2.05348 13.551 2.42072 15.0991 3.11565 16.4776L3.22606 16.6961L12.0156 7.90673L20.7851 16.6766ZM12.0002 24C14.9877 24 17.7208 22.9084 19.8215 21.1017L12.0161 13.2959L4.19601 21.1153C6.29377 22.9142 9.01265 24 12.0002 24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7289_2190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZircuit);
export default __webpack_public_path__ + "static/media/zircuit.b872e0adfa279175976c54a794a5d873.svg";
export { ForwardRef as ReactComponent };